<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>技專資料庫專區</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li>
						<router-link to="/">
							<i class="fa fa-home"></i>
						</router-link>
					</li>
					<li>技專資料庫專區</li>
				</ol>
			</div>
		</header>
		<main>
			<section class="panel panel-default" style="margin-bottom: 0px;">
				<header class="panel-heading" style="padding: 10px;">
					<div class="panel-actions" style="top: 7px;">
						<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
					</div>
					<h4 class="panel-title">&emsp;</h4>
				</header>
				<div class="tab-content">
					<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
						<div class="row form-group">
							<div class="col-md-12 form-group">
								請選擇匯出表格:
								<select v-model="exportType">
									<option value="">請選擇</option>
									<option v-for="(item, key) in exportTypeList" :key="key" :value="item.key">{{item.txt}}</option>
								</select>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-12 form-group text-center">
								<a href="#" @click.prevent="exportReport" class="btn-upload btn btn-primary" style="background-color:#0044BB; border-color:#0044BB;">確認匯出</a>
							</div>
						</div>
					</div>
				</div>
			</section>
		</main>
	</section>
	
</template>
<script>
export default {
	data(){
		return{
			exportType:"",
		}
	},
	methods:{
		exportReport(){
			let s = this.exportTypeList.filter(item =>{
				return item.key == this.exportType;
			});
			if(s.length > 0){
				const api = `/api/TechnoDataBase/${this.exportType}`;
				this.$axios.post( api, null, { 
					headers: { "Content-Type": "application/json" },
					responseType: "blob" 
				}).then(resp => {
					const url = window.URL.createObjectURL(new Blob([resp.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", s[0].txt+"_"+this.customFormatter(new Date())+".xlsx");
					document.body.appendChild(link);
					link.click();
				});
			}
			
		}
	},
	computed:{
		exportTypeList(){
			let optionLst = [];
			if(this.isAdmin("tenancy")){
				optionLst.push({
					key:"exportStayHouseUseReport",
					txt:"學校學生宿舍使用資料表"
				});
				optionLst.push({
					key:"exportStuStayStateReport",
					txt:"學校學生住宿狀況資料表"
				});
			}
			if(this.isAdmin("stipendMage")){
				optionLst.push({
					key:"exportStipendMageReport",
					txt:"學校學生助學金使用資料表"
				});
			}
			return optionLst;
		}
	}
}
</script>